import { Modal, Text } from "@eventsquare/uikit";
import { ReactElement } from "react";
import styles from "./OrderDetailModal.module.scss";

interface OrderItem {
  name: string;
  amount: number;
  unit_price: string;
}

interface Order {
  id: string | number;
  customer: string;
  ordered_at: string;
  price: string;
  payment_method: string;
  order: OrderItem[];
}

interface DetailModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  order: Order | null;
  formatDate: (dateString: string) => string;
  renderPaymentMethodIcon: (paymentMethod: string) => ReactElement;
}

const OrderDetailModal = ({
  showModal,
  setShowModal,
  order,
  formatDate,
  renderPaymentMethodIcon,
}: DetailModalProps) => {
  const closeModal = () => {
    setShowModal(false);
  };

  const calculateItemTotal = (unitPrice: string, amount: number): string => {
    try {
      const price = parseFloat(unitPrice.replace("$", ""));
      if (isNaN(price)) return "N/A";
      return `$${(price * amount).toFixed(2)}`;
    } catch {
      return "N/A";
    }
  };

  return (
    <Modal isVisible={showModal} closeModal={closeModal}>
      {order ? (
        <div className={styles.orderDetail}>
          <div className={styles.orderDetailHeader}>
            <div className={styles.orderDetailHeaderTitle}>
              <Text variant="h4" noMargin>
                {order.customer}
              </Text>
              <Text variant="small" noMargin>
                {formatDate(order.ordered_at)}
              </Text>
            </div>
            <div className={styles.orderDetailHeaderIcon}>
              {renderPaymentMethodIcon(order.payment_method)}
            </div>
          </div>
          <div className={styles.orderDetailBody}>
            {order.order.map((item, index) => (
              <div key={index} className={styles.orderDetailItem}>
                <div className={styles.orderDetailItemName}>
                  <Text variant="h5" noMargin>
                    {item.name}
                  </Text>
                </div>
                <div className={styles.orderDetailItemDetails}>
                  <div className={styles.orderDetailItemAmount}>
                    <Text variant="small" noMargin>{`${item.amount}x`}</Text>
                  </div>
                  <div className={styles.orderDetailItemUnitPrice}>
                    <Text variant="small" noMargin>
                      {item.unit_price}
                    </Text>
                  </div>
                  <div className={styles.orderDetailItemTotalPrice}>
                    <Text variant="small" noMargin>
                      {calculateItemTotal(item.unit_price, item.amount)}
                    </Text>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.orderDetailFooter}>
            <div className={styles.orderDetailFooterTotal}>
              <Text variant="h5" noMargin>
                TOTAL:
              </Text>
            </div>
            <div>
              <Text variant="h5" noMargin>
                {order.price}
              </Text>
            </div>
          </div>
        </div>
      ) : (
        <Text variant="small" noMargin>
          No order selected
        </Text>
      )}
    </Modal>
  );
};

export default OrderDetailModal;
